import { UserResponseDto } from "../shared/dtos/user/UserResponseDto";
import { UserSummaryDto } from "../shared/dtos/user/UserSummaryDto";

export class UserMapper {
  public static mapUserToSummary(
    detailedUser: UserResponseDto,
  ): UserSummaryDto {
    return {
      id: detailedUser.id,
      firstName: detailedUser.firstName,
      middleName: detailedUser.middleName,
      lastName: detailedUser.lastName,
      email: detailedUser.email,
      branchId: detailedUser.branchId,
      branchName: detailedUser.branchName,
      userRole: detailedUser.userRole,
      userStatus: detailedUser.userStatus,
      createdAt: detailedUser.createdAt,
    };
  }
}
